import type { FC } from 'react';
import 'app/pages/hosted-checkout/components/ProductRow/styles.scss';

const ProductRow: FC<ProductRowProps> = ({ quantity, quantityLabel, unitPrice, name }) => (
  <li className="product-row" key={name} data-testid="productrow">
    <div className="product-row__name">
      <p>{name}</p>
      <p className="product-row__quantity">
        {quantityLabel}:
        <span className="product-row__quantity-label">
          {quantity > 1 && <span>x</span>}
          {quantity}
        </span>
      </p>
    </div>
    <span className="product-row__price">{unitPrice}</span>
  </li>
);

interface ProductRowProps {
  quantity: number;
  quantityLabel: string;
  unitPrice: string;
  name: string;
}

export default ProductRow;
